import { z } from "zod";
import type { InboxMessage } from "../../src/inbox-v2/contract.ts";
import { replyRecipients } from "../../src/inbox-v2/reply-recipients.ts";
import { ReplyAllArrowIcon, ReplyArrowIcon } from "../icons.tsx";
import { MailAction } from "./message-actions.tsx";

export const OPEN_REPLY_MESSAGE = "leadcue-open-reply-message";
const ReplySourceSchema = z.strictObject({
  workspaceId: z.string(),
  planId: z.string(),
  messageId: z.string().regex(/^bison:reply:[1-9]\d*$/u),
  all: z.boolean().default(false),
});

/** Asks for a reply to this message, to its sender or to everyone on it (`thread-boxes.tsx`). */
export function openReply(workspaceId: string, planId: string, messageId: string, all: boolean) {
  window.dispatchEvent(
    new CustomEvent(OPEN_REPLY_MESSAGE, { detail: { workspaceId, planId, messageId, all } }),
  );
}

/** Whether a reply all here reaches anyone the plain reply does not. */
export function hasOthers(message: InboxMessage, mailbox: string | null | undefined): boolean {
  return (
    message.direction === "inbound" &&
    !!mailbox &&
    (replyRecipients(message, mailbox, true)?.cc.length ?? 0) > 0
  );
}

/** A sent reply still answers the lead; sequence messages wait for the parent probe. */
export function ReplyMessageAction(props: {
  workspaceId: string;
  planId: string;
  message: InboxMessage;
  mailbox?: string | null;
}) {
  if (!ReplySourceSchema.shape.messageId.safeParse(props.message.id).success) return null;
  const open = (all: boolean) => openReply(props.workspaceId, props.planId, props.message.id, all);
  return (
    <>
      <MailAction
        label={props.message.direction === "outbound" ? "Reply to lead" : "Reply"}
        icon={<ReplyArrowIcon size={18} />}
        onClick={() => open(false)}
      />
      {hasOthers(props.message, props.mailbox) && (
        <MailAction
          label="Reply all"
          icon={<ReplyAllArrowIcon size={18} />}
          onClick={() => open(true)}
        />
      )}
    </>
  );
}
